<div class="mt-8">
  <div class="mt-4">
    <!--    @if (checkPermission('pesquisar-paginado')) {-->
    <!--      <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
    <!--    }-->
    <div>
      @if (!loading) {
        <div>
          <table-list-tariff
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="selectItem($event)"
          />
          @if (itemsList.length > 0) {
            <pagination
              [currentPage]="page"
              [pageSize]="rows"
              [totalRecords]="numberRows"
              (pageChanged)="pageChanged($event)"
            />
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
